/**
 * Whether the map can be drawn at all, and the settings it needs.
 *
 * Kept apart from `map-view.js` so that asking the question does not drag a
 * megabyte of mapping library in with it. Startup needs the answer — to know
 * whether to load the map at all — and the library itself only later, if the
 * visitor ever looks at the map.
 */

export const MAPTILER_KEY = import.meta.env.VITE_MAPTILER_KEY ?? '';
export const MAPTILER_STYLE = import.meta.env.VITE_MAPTILER_STYLE || 'streets-v2';

export function isMapConfigured() {
  return MAPTILER_KEY.trim().length > 0;
}
